/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_tdee_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintenance (TDEE)`)
};

const es_bmr_tdee_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenimiento (GEDT)`)
};

const de_bmr_tdee_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhaltungsbedarf (TDEE)`)
};

const nl_bmr_tdee_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderhoud (TDEE)`)
};

const fr_bmr_tdee_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintenance (TDEE)`)
};

const it_bmr_tdee_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenimento (TDEE)`)
};

const pt_br2_bmr_tdee_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manutenção (GET)`)
};

const pt_bmr_tdee_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manutenção (TDEE)`)
};

const ja_bmr_tdee_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`維持カロリー (TDEE)`)
};

const zh_bmr_tdee_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`维持热量（TDEE）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_tdee_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_tdee_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_tdee_label", locale)
	if (locale === "en") return en_bmr_tdee_label(inputs)
	if (locale === "es") return es_bmr_tdee_label(inputs)
	if (locale === "de") return de_bmr_tdee_label(inputs)
	if (locale === "nl") return nl_bmr_tdee_label(inputs)
	if (locale === "fr") return fr_bmr_tdee_label(inputs)
	if (locale === "it") return it_bmr_tdee_label(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_tdee_label(inputs)
	if (locale === "pt") return pt_bmr_tdee_label(inputs)
	if (locale === "ja") return ja_bmr_tdee_label(inputs)
	return zh_bmr_tdee_label(inputs)
};